'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function LCFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-11yhtannh", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-11yhtannh)" }, /* @__PURE__ */ React.createElement("path", { fill: "#7ccff5", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M16 4l8 16H8z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M16 8l7 12H9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M16 14l8 6H8z" })))
  );
}

export { LCFlag };
//# sourceMappingURL=LC.mjs.map
